import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';
var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';

// bonus
export function bonusAjaxTable(limit,pagination,id,created_at,bonus_type,total_value,from_master_id,master_id){
	const data = request({
		url: config.url+'bonus/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&bonus_type=' + bonus_type + '&total_value=' + total_value + '&from_master_id=' + from_master_id + '&master_id=' + master_id,
		method: 'get'
	});

	return Promise.resolve(data);
}

// pending
export function pendingAjaxTable(limit,pagination,id,created_at,sales_type,bonus_type,total_value,from_master_id,master_id,is_pay){
	const data = request({
		url: config.url+'pending/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&bonus_type=' + bonus_type + '&total_value=' + total_value + '&from_master_id=' + from_master_id + '&master_id=' + master_id + '&sales_type=' + sales_type + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

// transfer
export function transferAjaxTable(limit,pagination,id,created_at,code,from_master_id,to_master_id,transaction_type,total_amount){
	const data = request({
		url: config.url+'transfer/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function checkUser(user){
	const data = request({
		url: config.url+'transfer/checkUser?to_user='+user,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getTransferTopup(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'transfer/topup?language=' + language,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function transferTopup(postData){
	const data = request({
		url: config.url+'transfer/DBtopup',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getTransferDeduct(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'transfer/deduct?language=' + language,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function transferDeduct(postData){
	const data = request({
		url: config.url+'transfer/DBdeduct',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getTransferTopupGCA(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'transfer/topup_gca?language=' + language,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function transferTopupGCA(postData){
	const data = request({
		url: config.url+'transfer/DBtopup_gca',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function transferTopupGCAValidate(postData){
	const data = request({
		url: config.url+'transfer/validateTopup_gca',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getTransferDeductGCA(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'transfer/deduct_gca?language=' + language,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function transferDeductGCA(postData){
	const data = request({
		url: config.url+'transfer/DBdeduct_gca',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function transferDeductGCAValidate(postData){
	const data = request({
		url: config.url+'transfer/validateDeduct_gca',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}
// withdraw
export function withdrawAjaxTable(limit,pagination,id,created_at,completed_at,master_id,wallet_id,total_amount,coin_address,ip_address,remark,status_name,trader_id,login){
	const data = request({
		url: config.url+'withdraw/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&completed_at=' + completed_at + '&master_id=' + master_id + '&wallet_id=' + wallet_id + '&total_amount=' + total_amount + '&coin_address=' + coin_address + '&ip_address=' + ip_address + '&remark=' + remark + '&status_name=' + status_name + '&trader_id=' + trader_id + '&login=' + login,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function withdrawInfo(id){
	const data = request({
		url: config.url+'withdraw/info?id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getWithdrawEdit(id){
	const data = request({
		url: config.url+'withdraw/edit?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function withdrawEdit(postData){
	const data = request({
		url: config.url+'withdraw/edit',
		method: 'post',
		data:postData
	});

	return Promise.resolve(data);
}

export function withdrawExport(start,end){
	const data = request({
		url: config.url+'withdraw/export_withdraw_list?date_start='+start+'&date_end='+end,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function withdrawImport(postData){
	const data = request({
		url: config.url+'withdraw/import',
		method: 'post',
		data:postData
	});

	return Promise.resolve(data);
}

export function withdrawSendTelegram(postData){
	const data = request({
		url: config.url+'withdraw/sendTelegram',
		method: 'post',
		data:postData
	});

	return Promise.resolve(data);
}

export function withdrawRemarkClear(postData){
	const data = request({
		url: config.url+'withdraw/clearRemark',
		method: 'post',
		data:postData
	});

	return Promise.resolve(data);
}
// bonus static
export function bonusStaticAjaxTable(limit,pagination,id,created_at,bonus_type,total_value,from_master_id,master_id){
	const data = request({
		url: config.url+'bonus_static/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&bonus_type=' + bonus_type + '&total_value=' + total_value + '&from_master_id=' + from_master_id + '&master_id=' + master_id,
		method: 'get'
	});

	return Promise.resolve(data);
}

// pending static
export function pendingStaticAjaxTable(limit,pagination,id,created_at,sales_type,bonus_type,total_value,from_master_id,master_id,is_pay){
	const data = request({
		url: config.url+'pending_static/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&bonus_type=' + bonus_type + '&total_value=' + total_value + '&from_master_id=' + from_master_id + '&master_id=' + master_id + '&sales_type=' + sales_type + '&is_pay=' + is_pay,
		method: 'get'
	});

	return Promise.resolve(data);
}

// complete withdraw
export function completeWithdrawAjaxTable(limit,pagination,completed_at,master_id,trader_id,wallet_id,total_coin_amount,tx_id){
	const data = request({
		url: config.url+'completed_withdraw/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&completed_at=' + completed_at + '&master_id=' + master_id + '&trader_id=' + trader_id + '&wallet_id=' + wallet_id + '&total_coin_amount=' + total_coin_amount + '&tx_id=' + tx_id,
		method: 'get'
	});

	return Promise.resolve(data);
}

// trade withdraw
export function traderWithdrawAjaxTable(limit,pagination,trader,status,date_start,date_end){
	const data = request({
		url: config.url+'trader_withdraw/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&trader='+trader + '&status='+status + '&date_start='+date_start+'&date_end='+date_end,
		method: 'get'
	});

	return Promise.resolve(data);
}

// topup gca
export function topupGcaAjaxTable(limit,pagination,id,created_at,login,remark){
	const data = request({
		url: config.url+'topup_gca/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&login=' + login + '&remark=' + remark,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function topupGcaImport(postData){
	const data = request({
		url: config.url+'topup_gca/upload',
		method: 'post',
		data:postData
	});

	return Promise.resolve(data);
}